import { useEffect, useState } from "react";
import styles from "./RoundIntroOverlay.module.css";

export interface RoundIntroOverlayProps {
  eyebrow: string;
  title: string;
  onDone: () => void;
  durationMs?: number;
}

const DEFAULT_DURATION_MS = 1600;

/**
 * Full-screen "here's what this round is" announcement, shown before a
 * round's content becomes interactive and its timer starts — specifically
 * for Beeline, where each round is a different mini-mode (sort by distance,
 * north-to-south, near-or-far duels, estimate distance) rather than the same
 * mechanic repeated. Blocks interaction with the round underneath (unlike
 * PointsBurst, which never blocks) until it auto-dismisses.
 */
export function RoundIntroOverlay({ eyebrow, title, onDone, durationMs = DEFAULT_DURATION_MS }: RoundIntroOverlayProps) {
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const closeTimer = window.setTimeout(() => setClosing(true), durationMs - 300);
    const doneTimer = window.setTimeout(onDone, durationMs);
    return () => {
      window.clearTimeout(closeTimer);
      window.clearTimeout(doneTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [durationMs]);

  return (
    <div className={`${styles.overlay} ${closing ? styles.closing : ""}`} role="status" aria-live="polite">
      <div className={styles.card}>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <p className={styles.title}>{title}</p>
      </div>
    </div>
  );
}
